// extracted by mini-css-extract-plugin
export default {"link":"OGBeanContent_link__32+a3","currentBidCol":"OGBeanContent_currentBidCol__jfSV1","bidRow":"OGBeanContent_bidRow__CORVt"};